export default "<div class=\"slot-machine-scene\">\n  <app-slot-machine></app-slot-machine>\n</div>\n";